import { render, staticRenderFns } from "./relatorioChatsFinalizados.vue?vue&type=template&id=da92bab0&scoped=true"
import script from "./relatorioChatsFinalizados.vue?vue&type=script&lang=js"
export * from "./relatorioChatsFinalizados.vue?vue&type=script&lang=js"
import style0 from "./relatorioChatsFinalizados.vue?vue&type=style&index=0&id=da92bab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da92bab0",
  null
  
)

export default component.exports